import authorizationReducer from '../reducers/authorization-slice';
import messageReducer from '../reducers/message-slice';
import walletReducer from '../reducers/wallet-slice';
import mentorReducer from '../reducers/mentor-slice';
import languageReducer from '../reducers/language-slice';
import rolesReducer from '../reducers/roles-slice';
import validationReducer from '../reducers/validation-slice';
import counterReducer from '../../test/counter/counterSlice';
import { authApi } from '../../domains/auth/infrastructure/api/auth.api';
import { userApi } from '../../domains/user/infrastructure/api/user.api';
import { categoryApi } from '../../domains/category/infrastructure/api/category.api';
import { mentorApi } from '../../domains/mentor/infrastructure/api/mentor.api';
import { lessonOfferingsApi } from '../../domains/lesson/infrastructure/api/lessonOfferings.api';
import { studentProfileApi } from '../../domains/student/infrastructure/api/student-profile.api';
import { publicProfileApi } from '../../domains/public/infrastructure/api/public-profile.api';
import { notificationsApi } from '../../domains/notification/infrastructure/api/notifications.api';
import { conversationApi } from '../../domains/conversation/infrastructure/api/conversation.api';
import { searchApi } from '../../domains/search/infrastructure/api/search.api';
import userReducer from '../../domains/user/infrastructure/slices/userSlice';
import type { DomainConfig } from './types';

export const domainRegistry: DomainConfig[] = [
  { name: 'authorization', reducer: authorizationReducer },
  { name: 'user', reducer: userReducer },
  {
    name: authApi.reducerPath,
    reducer: authApi.reducer,
    middleware: [authApi.middleware],
  },
  {
    name: userApi.reducerPath,
    reducer: userApi.reducer,
    middleware: [userApi.middleware],
  },
  {
    name: categoryApi.reducerPath,
    reducer: categoryApi.reducer,
    middleware: [categoryApi.middleware],
  },
  {
    name: mentorApi.reducerPath,
    reducer: mentorApi.reducer,
    middleware: [mentorApi.middleware],
  },
  {
    name: lessonOfferingsApi.reducerPath,
    reducer: lessonOfferingsApi.reducer,
    middleware: [lessonOfferingsApi.middleware],
  },
  {
    name: studentProfileApi.reducerPath,
    reducer: studentProfileApi.reducer,
    middleware: [studentProfileApi.middleware],
  },
  {
    name: publicProfileApi.reducerPath,
    reducer: publicProfileApi.reducer,
    middleware: [publicProfileApi.middleware],
  },
  {
    name: notificationsApi.reducerPath,
    reducer: notificationsApi.reducer,
    middleware: [notificationsApi.middleware],
  },
  {
    name: conversationApi.reducerPath,
    reducer: conversationApi.reducer,
    middleware: [conversationApi.middleware],
  },
  {
    name: searchApi.reducerPath,
    reducer: searchApi.reducer,
    middleware: [searchApi.middleware],
  },
  { name: 'message', reducer: messageReducer },
  { name: 'walletInfo', reducer: walletReducer },
  { name: 'mentor', reducer: mentorReducer },
  { name: 'roles', reducer: rolesReducer },
  { name: 'validations', reducer: validationReducer },
  { name: 'language', reducer: languageReducer },
  { name: 'counter', reducer: counterReducer },
];
